import Navbar from "../Navbar";
import Footer from "../Footer";
import ContactSection from "../ContactSection";
import scbcBanner from "../images/banners/scbc-banner.jpg";

function SCBC() {
  return (
    <>
      <Navbar />

      {/* FULL BANNER IMAGE */}
      <div className="scbc-banner">
        <img src={scbcBanner} alt="SCBC Banner" />
      </div>

      {/* MAIN CONTENT */}
      <div className="scbc-container">

        <h2>Shri Chandra Bulk Cargo Services Private Limited</h2>

        <p>
          SCBC is an ISO & AEO certified International Shipping and Logistics Company.  With a strong network of operations & offices across both the eastern and western coasts of India including all major & minor ports, we are a professional Customs House Agency (CHA) adept at tailoring solutions to meet your unique business needs. We also undertake Vessel Agency functions, Stevedoring, Warehousing Facilitation, Underwater services, Seismic Surveys, Dredging and Shore base management along with Agency & Husbandry services making us the one-stop-shop for all your shipping needs. Our end-to-end solutions are multi-modal and seamlessly integrated to give you exceptional service offerings. Our ability to preempt contingencies is drawn from decades of rich experience in the field. Our performance has earned us numerous accolades and awards (Top CHA Award by Government of India’s Customs Department) catapulting us to the top as the most dynamic game changer in the market. We are proficient in handling a diverse portfolio of commodities that include;        </p>

        <ul className="bullet-list">
          <li>Oil & Gas (Exploration & Production) Clearances & Allied Services</li>
          <li>Liquid Bulk Cargo Clearances</li>
          <li>General Bulk Cargo Clearances</li>
          <li>Out Of Gauge/Over Dimension</li>
          <li>Project Cargo Clearances</li>
          <li>Dangerous Hazardous Cargo Clearances</li>
          <li>Containerized Cargo Clearances</li>
          <li>Air Cargo Clearances</li>
        </ul>

        <h3>Oil & Gas (Exploration & Production) Clearances & Allied Services</h3>

        <div className="two-column">
          <ul>
            <li>Obtaining statutory licenses & permissions for oil & gas exploration and production</li>
            <li>Import / Export / Re-export clearance of equipment and vessel rigs, tugs.</li>
            <li>Obtaining Duty Exemption Certificate by Operator</li>
            <li>Obtain specific period license from Directorate General of Shipping</li>
            <li>Naval clearances and inspection</li>
            <li>Clearances from Ministry of Home Affairs ( MOHA ) for foreign expats</li>
            <li>Licenses from Directorate General of Foreign Trade (DGFT)</li>
            <li>Specific permissions from MMD</li>
            <li>Technical and manpower deployment</li>
            <li>NED passes</li>
            <li>Foreign ship crew sign-on/sign-off</li>
            <li>Supply of logistic services (logistics arrangement by road, rail, sea and air)</li>
            <li>Bunkers supply for ships</li>
          </ul>

          <ul>
            <li> Consultancy and liaison services in port operations</li>
            <li>Underwater services</li>
            <li>Heavy equipment supply</li>
            <li>Hotel booking and accommodation</li>
            <li>Cab supply</li>
            <li>Visa extension</li>
            <li>Immigration</li>
            <li>Labor permit</li>
            <li>Quarantine</li>
            <li>Shore base management</li>
            <li>Explosive licenses</li>
            <li>Trans-shipment permits</li>
            <li>Ship certifications</li>
            <li>FRRO</li>
            <li>Arrangement of class surveys</li>
          </ul>
        </div>

         <h3>Liquid Bulk Cargo Clearances</h3>
        <h3>General Bulk Cargo Clearances</h3>
        <h3>Out Of Gauge/Over Dimension </h3>
        <h3>Project Cargo Clearances</h3>
        <h3>Dangerous Hazardous Cargo Clearances</h3>
        <h3>Containerized Cargo Clearances </h3>
        <h3>Out Of Gauge/Over Dimension</h3>

        <h3>Air Cargo Clearance</h3>

        <div className="two-column">
          <ul>
            <li>Customs clearance</li>
            <li>Warehousing and stock maintenance</li>
            <li>Bonded Warehouse license processing</li>
            <li>Into bond clearances</li>
            <li>Exbond clearances</li>
            <li>On board stevedoring</li>
            <li>Port services</li>
            <li>End-to-end Logistics</li>
          </ul>

          <ul>
            <li>PGA (Partner Government Agency) Documentation processing</li>
            <li>DG cargo storage</li>
            <li>Container clearance</li>
            <li>Container inspection</li>
            <li>DG cargo storage</li>
            <li>Loading and unloading operations</li>

          </ul>
        </div>

        <h3>Agency Services</h3>
        <ul className="bullet-list">
          <li>Rapport with port authorities for allotment of suitable berths on vessels’ arrival to the port (unless all suitable berths are pre-occupied)</li>
          <li>Sound knowledge in getting the permissions done at Director General of Shipping, Mecantile Marine Department and Naval Office.</li>
          <li>Crew sign on /off matters and obtaining of travel permits and visa renewals/ extensions</li>
          <li>Extension of De-ratting Certs validity & Quarantine clearances</li>
          <li>Supply arrangements of Ships’ stores on exigency matters</li>
          <li>Arrangement of repairs, tank cleaning, hatch cleaning gangs to meet vessels’ requirement from time to time basis</li>
          <li>Supply arrangements of Ships’ stores on exigency mattersIn the event of emergency, arrangement of Ships’ required gear</li>
          <li>Arrangement of Travel (Domestic/International) for ship’ officers/ crew and company personnel</li>
          <li>The company is also well-connected to local suppliers, thereby ensuring a fast turnaround of vessels and smooth operations at competitive spirit</li>
          <li>Coordinating the loading and discharging of vessels with Port Authorities</li>
          <li>Clearance of Vessels from the Customs front for compliance of on arrival formalities, Entry inwards/outwards, Preventive and Rummage departments and bond store</li>
           <li>Co-coordinating loading / discharging with various cargo interests in Indian Ports</li>
            <li>Determining order of loading / discharging of vessels for best efficiency with regard to project and over dimensional cargoes</li>
             <li>On-line reports to clients</li>
              <li>Customs clearance services</li>
        </ul>

        <h3>Husbandry Services</h3>
        <ul className="bullet-list">
          <li>SCBC acts regularly attending and assisting as protecting agents for various vessel owners calling Indian ports, providing 24/7 service to meet all needs of both vessel and crew</li>
          <li>Telephone services / mobile phone for ship's master</li>
          <li>Supply of fresh water, provisions, bunkers & lube oil</li>
          <li>Medical services</li>
          <li>Mail and courier services</li>
           <li>Co-ordination of repairs when required including ship yard repairs</li>
            <li>Crew sign on / off services</li>
             <li>FRRO registration services and co-ordination</li>
              <li>Visa extension and travel permits sanction services Out Of Gauge/Over Dimension</li>
              <li>Logistics support services</li>
              <li>Permissions for Coastal conversion to vessels</li>
              <li>Permission for Coastal Licenses</li>
              <li>Cargo Import / Re-Export clearance</li>
        </ul>

      </div>

      <ContactSection />
      <Footer />
    </>
  );
}

export default SCBC;
